// import React, { useState } from 'react';
// import ReactECharts from 'echarts-for-react';
// import { Dropdown } from 'react-bootstrap';

// // Example options for dropdowns
// const companyOptions = [
//     { value: 'company-a', label: 'Company A' },
//     { value: 'company-b', label: 'Company B' },
//     { value: 'company-c', label: 'Company C' },
// ];

// const LicenceSpliteUpChart = () => {
//     const [selectedCompany, setSelectedCompany] = useState(companyOptions[0]);

//     const handleCompanySelect = (company) => {
//         setSelectedCompany(company);
//     };

//     const option = {
//         title: {
//             text: 'Licence Split Up',
//             left: 'left',
//             textStyle: {
//                 fontSize: 16,
//             },
//         },
//         tooltip: {
//             trigger: 'axis',
//             axisPointer: {
//                 type: 'shadow',
//             },
//             formatter: (params) => {
//                 let tooltipContent = `${params[0].name}<br/>`;
//                 params.forEach((item) => {
//                     tooltipContent += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
//                 });
//                 return tooltipContent;
//             },
//         },
//         legend: {
//             data: ['Total Licence', 'Licence Assigned', 'Available Licence'],
//             top: 20,
//         },
//         grid: {
//             left: '3%',
//             right: '4%',
//             bottom: '3%',
//             containLabel: true,
//         },
//         xAxis: {
//             type: 'category',
//             data: ['Branch 1', 'Branch 2', 'Branch 3', 'Branch 4'],
//         },
//         yAxis: {
//             type: 'value',
//         },
//         series: [
//             {
//                 name: 'Total Licence',
//                 type: 'bar',
//                 data: [10, 12, 9, 14],
//                 itemStyle: {
//                     color: '#000000',
//                 },
//             },
//             {
//                 name: 'Licence Assigned',
//                 type: 'bar',
//                 data: [7, 8, 5, 10],
//                 itemStyle: {
//                     color: '#00FF00',
//                 },
//             },
//             {
//                 name: 'Available Licence',
//                 type: 'bar',
//                 data: [3, 4, 4, 4],
//                 itemStyle: {
//                     color: '#FF0000',
//                 },
//             },
//         ],
//     };

//     return (
//         <div style={{ border: '2px solid #007bff', borderRadius: '8px', padding: '15px', background: '#fff' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
//                 <h6 style={{ margin: 0 }}>Licence Split Up</h6>
//                 <Dropdown>
//                     <Dropdown.Toggle id="dropdown-company">
//                         {selectedCompany.label}
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                         {companyOptions.map(option => (
//                             <Dropdown.Item
//                                 key={option.value}
//                                 onClick={() => handleCompanySelect(option)}
//                                 active={selectedCompany.value === option.value}
//                             >
//                                 {option.label}
//                             </Dropdown.Item>
//                         ))}
//                     </Dropdown.Menu>
//                 </Dropdown>
//             </div>
//             <ReactECharts option={option} style={{ height: 250 }} />
//         </div>
//     );
// };

// export default LicenceSpliteUpChart;


import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Chart, BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadCompanyDropdownData, loadCustomerDashboardLicenceSplitUpChartData, loadLicenceDashboardBarchartLicenseSplitUpData } from '../../redux/action';
import * as ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { jsPDF } from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, HeadingLevel, ImageRun } from "docx";
import html2canvas from 'html2canvas';
import { useLocation } from 'react-router-dom';

Chart.register(BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend);

// Example options for dropdowns
const companyOptions = [
    { value: 'company-a', label: 'Company A' },
    { value: 'company-b', label: 'Company B' },
    { value: 'company-c', label: 'Company C' },
];

// const LicenceSpliteUpChart = () => {
const LicenceSpliteUpChart = React.forwardRef((_, ref) => {
    let dispatch = useDispatch();
    const location = useLocation();

    const { getCustomerDashboardLicenceSplitUpData } = useSelector((state) => state.data);
    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { getLicenceDashboardBarChartLicenceSplitUpData } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;

    const [selectedCompany, setSelectedCompany] = useState({ value: storedCompanyId, label: storedCompanyName });
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
    };

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    // useEffect(() => {
    //     dispatch(loadCustomerDashboardLicenceSplitUpChartData(selectedCompany.value)); // Pass the selected year to the action
    // }, [selectedCompany, dispatch]);
    // useEffect(() => {
    //     dispatch(loadLicenceDashboardBarchartLicenseSplitUpData(selectedCompany.value)); // Pass the selected year to the action
    // }, [selectedCompany, dispatch]);

    useEffect(() => {
        if (selectedCompany) {
            if (location.pathname === "/licenceDashboard") {
                dispatch(loadLicenceDashboardBarchartLicenseSplitUpData(selectedCompany.value));
            } else {
                dispatch(loadCustomerDashboardLicenceSplitUpChartData(selectedCompany.value));
            }
        }
    }, [selectedCompany, dispatch, location.pathname]);

    useEffect(() => {
        const selectedData =
            location.pathname === "/licenceDashboard"
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

        if (!selectedData || selectedData.length === 0) return;

        const ctx = chartRef.current.getContext("2d");

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        const branchNames = selectedData.map((item) => item.BranchName);
        const BranchCode = selectedData.map((item) => item.BranchCode);
        const totalLicenses = selectedData.map((item) => item.BranchTotalLicenses);
        const assignedLicenses = selectedData.map((item) => item.BranchAssignedLicenses);
        const availableLicenses = selectedData.map((item) => item.BranchAvailableLicenses);

        chartInstance.current = new Chart(ctx, {
            type: "bar",
            data: {
                labels: BranchCode,
                datasets: [
                    {
                        label: "Total Licence",
                        data: totalLicenses,
                        backgroundColor: "#2C2C2C",
                        barThickness: 6,
                        borderRadius: 5,
                        borderSkipped: false,
                    },
                    {
                        label: "Licence Assigned",
                        data: assignedLicenses,
                        backgroundColor: "#3AC977",
                        barThickness: 6,
                        borderRadius: 5,
                        borderSkipped: false,
                    },
                    {
                        label: "Available Licence",
                        data: availableLicenses,
                        backgroundColor: " #FF5E5E",
                        barThickness: 6,
                        borderRadius: 5,
                        borderSkipped: false,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: "rgba(246, 246, 246, 1)",
                        },
                    },
                },
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                const branchIndex = tooltipItem.dataIndex;
                                const branchName = branchNames[branchIndex];
                                const datasetLabel = tooltipItem.dataset.label;
                                const value = tooltipItem.raw;
                                return [`Branch: ${branchName}`, `${datasetLabel}: ${value}`];
                            },
                        },
                    },
                },
            },
        });

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [getCustomerDashboardLicenceSplitUpData, getLicenceDashboardBarChartLicenceSplitUpData, selectedCompany, location.pathname]);

    // Use `useImperativeHandle` to expose methods to the parent component
    useImperativeHandle(ref, () => ({
        handleDownloadExcel: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

            if (!chartData || !chartInstance.current) return;

            // Format the data for the worksheet
            const chartDataFormatted = chartData.map((item) => ({
                BranchID: item.BranchID,
                BranchName: item.BranchName,
                TotalLicenses: item.BranchTotalLicenses,
                AssignedLicenses: item.BranchAssignedLicenses,
                AvailableLicenses: item.BranchAvailableLicenses,
            }));

            // Get the chart image as a base64 string
            const chartImage = chartInstance.current.toBase64Image();

            // Create an Excel workbook
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Chart Data');

            // Define the columns for the worksheet
            worksheet.columns = [
                { header: 'Branch ID', key: 'BranchID', width: 15 },
                { header: 'Branch Name', key: 'BranchName', width: 30 },
                { header: 'Total Licenses', key: 'TotalLicenses', width: 20 },
                { header: 'Assigned Licenses', key: 'AssignedLicenses', width: 20 },
                { header: 'Available Licenses', key: 'AvailableLicenses', width: 20 },
            ];

            // Add data rows to the worksheet
            chartDataFormatted.forEach((data) => worksheet.addRow(data));

            // Add the chart image to the worksheet
            try {
                const imageId = workbook.addImage({
                    base64: chartImage,
                    extension: 'png',
                });
                worksheet.addImage(imageId, 'F5:H20'); // Adjust the range as needed
            } catch (error) {
                console.error('Error adding chart image:', error);
            }

            // Generate the Excel file and trigger download
            workbook.xlsx
                .writeBuffer()
                .then((buffer) => {
                    const blob = new Blob([buffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    saveAs(blob, isLicenceDashboard ? 'Licence_SplitUp_Chart.xlsx' : 'Customer_SplitUp_Chart.xlsx');
                })
                .catch((error) => {
                    console.error('Error downloading Excel file:', error);
                });
        },
        handleDownloadPDF: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

            if (!chartData || !chartInstance.current) return;

            // Format the data for the table
            const chartDataFormatted = chartData.map((item) => ({
                BranchID: item.BranchID,
                BranchName: item.BranchName,
                TotalLicenses: item.BranchTotalLicenses,
                AssignedLicenses: item.BranchAssignedLicenses,
                AvailableLicenses: item.BranchAvailableLicenses,
            }));

            // Initialize jsPDF
            const pdf = new jsPDF();
            pdf.setFontSize(18);
            pdf.text(
                isLicenceDashboard ? 'Licence Split Up Chart' : 'Customer Split Up Chart',
                20,
                20
            );

            // Set table columns and rows
            const columns = [
                { header: 'Branch ID', dataKey: 'BranchID' },
                { header: 'Branch Name', dataKey: 'BranchName' },
                { header: 'Total Licenses', dataKey: 'TotalLicenses' },
                { header: 'Assigned Licenses', dataKey: 'AssignedLicenses' },
                { header: 'Available Licenses', dataKey: 'AvailableLicenses' },
            ];

            const rows = chartDataFormatted;

            // Add table using autoTable plugin
            pdf.autoTable({
                columns,
                body: rows,
                startY: 30, // Position after the title
                headStyles: { fillColor: [22, 160, 133] }, // Optional: Custom styling
                theme: 'grid',
            });

            // Add chart image below the table
            const chartImage = chartInstance.current.toBase64Image();
            const finalY = pdf.autoTable.previous.finalY || 30; // Get Y position after the table
            pdf.addImage(chartImage, 'PNG', 20, finalY + 10, 170, 80);

            // Save the PDF
            pdf.save(
                isLicenceDashboard ? 'Licence_SplitUp_Chart.pdf' : 'Customer_SplitUp_Chart.pdf'
            );
        },
        handleDownloadWord: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

            if (!chartData || !chartInstance.current) return;

            // Format data for the Word table
            const chartDataFormatted = chartData.map((item) => ({
                BranchID: item.BranchID,
                BranchName: item.BranchName,
                TotalLicenses: item.BranchTotalLicenses,
                AssignedLicenses: item.BranchAssignedLicenses,
                AvailableLicenses: item.BranchAvailableLicenses,
            }));

            // Get the chart image as a base64 string
            const chartImage = chartInstance.current.toBase64Image();
            const base64Data = chartImage.split(",")[1];
            const byteArray = new Uint8Array(
                atob(base64Data)
                    .split("")
                    .map((char) => char.charCodeAt(0))
            );

            // Create table rows
            const tableRows = chartDataFormatted.map((data) => {
                return new TableRow({
                    children: [
                        new TableCell({ children: [new Paragraph(data.BranchID.toString())] }),
                        new TableCell({ children: [new Paragraph(data.BranchName)] }),
                        new TableCell({ children: [new Paragraph(data.TotalLicenses.toString())] }),
                        new TableCell({ children: [new Paragraph(data.AssignedLicenses.toString())] }),
                        new TableCell({ children: [new Paragraph(data.AvailableLicenses.toString())] }),
                    ],
                });
            });

            // Create the Word document
            const doc = new Document({
                sections: [
                    {
                        children: [
                            new Paragraph({
                                text: isLicenceDashboard
                                    ? "Licence Split Up Chart"
                                    : "Customer Split Up Chart",
                                heading: HeadingLevel.TITLE,
                            }),
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [new Paragraph("Branch ID")],
                                                shading: { fill: "CCCCCC" },
                                            }),
                                            new TableCell({
                                                children: [new Paragraph("Branch Name")],
                                                shading: { fill: "CCCCCC" },
                                            }),
                                            new TableCell({
                                                children: [new Paragraph("Total Licenses")],
                                                shading: { fill: "CCCCCC" },
                                            }),
                                            new TableCell({
                                                children: [new Paragraph("Assigned Licenses")],
                                                shading: { fill: "CCCCCC" },
                                            }),
                                            new TableCell({
                                                children: [new Paragraph("Available Licenses")],
                                                shading: { fill: "CCCCCC" },
                                            }),
                                        ],
                                    }),
                                    ...tableRows,
                                ],
                            }),
                            new Paragraph({ text: "Chart:" }),
                            new Paragraph({
                                children: [
                                    new ImageRun({
                                        data: byteArray,
                                        transformation: { width: 500, height: 300 },
                                    }),
                                ],
                            }),
                        ],
                    },
                ],
            });

            // Generate and save the Word document
            Packer.toBlob(doc)
                .then((blob) => {
                    saveAs(
                        blob,
                        isLicenceDashboard
                            ? "Licence_SplitUp_Chart.docx"
                            : "Customer_SplitUp_Chart.docx"
                    );
                })
                .catch((error) => console.error("Error generating Word document:", error));
        },
        handlePrint: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

            if (!chartData || !chartInstance.current) {
                console.error("Chart instance or data is not available.");
                return;
            }

            const chartCanvas = chartInstance.current.canvas;
            if (!chartCanvas) {
                console.error("Chart canvas is not available.");
                return;
            }

            // Create table HTML dynamically
            const tableHtml = `
                <table border="1" style="width: 100%; border-collapse: collapse; text-align: left;">
                    <thead>
                        <tr style="background-color: #16A085; color: white;">
                            <th>Branch ID</th>
                            <th>Branch Name</th>
                            <th>Total Licenses</th>
                            <th>Assigned Licenses</th>
                            <th>Available Licenses</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${chartData
                    .map(
                        (data) => `
                                    <tr>
                                        <td>${data.BranchID}</td>
                                        <td>${data.BranchName}</td>
                                        <td>${data.BranchTotalLicenses}</td>
                                        <td>${data.BranchAssignedLicenses}</td>
                                        <td>${data.BranchAvailableLicenses}</td>
                                    </tr>`
                    )
                    .join('')}
                    </tbody>
                </table>
            `;

            // Create the print window and add the content
            const printWindow = window.open('', '_blank');
            if (!printWindow) {
                console.error("Unable to open a new print window.");
                return;
            }

            printWindow.document.write('<html><head><title>Print Chart with Data</title></head><body>');
            printWindow.document.write(
                `<h1 style="text-align: center;">${isLicenceDashboard ? "Licence Split Up Chart" : "Customer Split Up Chart"
                }</h1>`
            );
            printWindow.document.write('<div style="margin-bottom: 20px; text-align: center;">' + tableHtml + '</div>');
            printWindow.document.write(
                '<div style="text-align: center;">' +
                '<img src="' +
                chartCanvas.toDataURL('image/png') +
                '" style="max-width: 100%; margin-top: 20px;" />' +
                '</div>'
            );
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.focus();

            // Print the document after ensuring it's ready
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        },
        handleDownloadImage: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard
                ? getLicenceDashboardBarChartLicenceSplitUpData
                : getCustomerDashboardLicenceSplitUpData;

            if (!chartData || !chartInstance.current) {
                console.error("Chart instance or data is not available.");
                return;
            }

            const chartImage = chartInstance.current.toBase64Image(); // Get the chart as an image

            // Prepare the table HTML dynamically
            const tableHtml = `
                <div style="margin-bottom: 20px;">
                    <table border="1" style="width: 100%; border-collapse: collapse; text-align: left;">
                        <thead>
                            <tr style="background-color: #16A085; color: white;">
                                <th>Branch ID</th>
                                <th>Branch Name</th>
                                <th>Total Licenses</th>
                                <th>Assigned Licenses</th>
                                <th>Available Licenses</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${chartData
                    .map(
                        (data) => `
                                        <tr>
                                            <td>${data.BranchID}</td>
                                            <td>${data.BranchName}</td>
                                            <td>${data.BranchTotalLicenses}</td>
                                            <td>${data.BranchAssignedLicenses}</td>
                                            <td>${data.BranchAvailableLicenses}</td>
                                        </tr>`
                    )
                    .join('')}
                        </tbody>
                    </table>
                </div>
            `;

            // Create a container for both the chart image and the table
            const container = document.createElement('div');
            container.innerHTML = `
                <h1 style="text-align: center;">${isLicenceDashboard ? "Licence Split Up Chart" : "Customer Split Up Chart"
                }</h1>
                ${tableHtml}
                <div style="text-align: center;">
                    <img src="${chartImage}" style="max-width: 100%; height: auto;" />
                </div>
            `;

            // Append the container to the body (for html2canvas to render properly)
            document.body.appendChild(container);

            // Wait for the content to fully render, then capture the image
            setTimeout(() => {
                html2canvas(container, { useCORS: true })
                    .then((canvas) => {
                        const link = document.createElement('a');
                        link.download = 'Chart_With_Data.png';
                        link.href = canvas.toDataURL('image/png');
                        link.click();

                        // Clean up: Remove the temporary container after download
                        document.body.removeChild(container);
                    })
                    .catch((error) => {
                        console.error('Error downloading image:', error);
                    });
            }, 1000); // Adjust time as necessary
        },
    }));

    return (
        <div className='barchart-container'>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <h6 style={{ margin: 0 }}>Licence Split Up</h6>
                <Dropdown>
                    <Dropdown.Toggle id="dropdown-company">
                        {selectedCompany?.label ? selectedCompany?.label : 'Select Company'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {getCompanyDropdown.map(option => (
                            <Dropdown.Item
                                key={option.value}
                                onClick={() => handleCompanySelect(option)}
                                active={selectedCompany.value === option.value}
                            >
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div className='barchart-canvas-container'>
                <canvas ref={chartRef} />
            </div>
        </div>
    );
});

export default LicenceSpliteUpChart;
